export const buildKioskMobileUrl = (
  storeId: number,
  path: string,
  params?: Record<string, string>
) => {
  const url = new URL(
    `/stores/${storeId}/mobile/${path}`,
    window.location.origin
  );

  Object.entries(params ?? {}).forEach(([key, value]) => {
    url.searchParams.set(key, value);
  });

  return url.toString();
};
